import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import ImageDisplay from '../ImageDisplay';
import OptionalCard from './OptionalCard';
import { RecurringMessageFrequencyType } from '../../../app/types';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      marginBottom: 12,
    },
    content: {
      display: 'flex',
      maxWidth: '100%',
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
      overflowX: 'auto',
      padding: '0 0 8px 0',
    },
  }),
  {
    name: 'RecurringMessagePreview',
  },
);

function RecurringMessagePreview({ orgIconURL, elements }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const cardComponents = elements.map((element, index) => {
    return (
      <OptionalCard
        key={`preview-recruuingMessage-card-${index}`}
        data={{
          imageUrl: element?.imageUrl,
          title: element?.title,
          subtitle: t(
            `recurringMessage:recurringMessagePreviewSubtitle.${
              element?.recurring?.frequency ||
              RecurringMessageFrequencyType.DAILY
            }`,
          ),
          buttons: [
            {
              type: 'postback',
              title: t(`recurringMessage:recurringMessagePreviewButton`),
            },
          ],
        }}
        index={index}
        messageIndex={0}
      />
    );
  });
  return (
    <div className={classes.root}>
      <ImageDisplay
        style={{ objectFit: 'cover', borderRadius: '50%', marginRight: 12 }}
        src={orgIconURL}
        width={44}
        height={44}
      />
      <div className={classes.content}>{cardComponents}</div>
    </div>
  );
}

export default RecurringMessagePreview;
